module.exports = "/_next/static/images/DigitalAdvertising-9498e1a69329570feae9cb1b566fedf7.png";